import { evalsConstants as evals } from "../../../constants/evaluations";

const initialState = {
  loading: false,
  list: [],
  data: null,
  types: [],
  type: null,
  notes: [],
  releve: null,
  pv: [],
  pvAnnuel: [],
  details: {
    taux: 0,
    creditsL1: 0,
    creditsL2: 0,
    creditsM1: 0,
  },
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case evals.GET_EVALUATIONS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case evals.GET_EVALUATION:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case evals.GET_TYPES:
      return {
        ...state,
        loading: false,
        types: payload,
      };
    case evals.GET_TYPE:
      return {
        ...state,
        loading: false,
        type: payload,
      };
    case evals.GET_NOTES:
      return {
        ...state,
        loading: false,
        notes: payload,
      };
    case evals.GET_RELEVE:
      return {
        ...state,
        loading: false,
        releve: payload,
      };
    case evals.GET_PV:
      return {
        ...state,
        loading: false,
        pv: payload,
      };
    case evals.GET_PV_ANNUEL:
      return {
        ...state,
        loading: false,
        pvAnnuel: payload,
      };
    case evals.GET_DETAILS:
      return {
        ...state,
        loading: false,
        details: payload,
      };
    case evals.SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
}
